/**
* [Flags]
*/
export var PickerActions;
(function (PickerActions) {
    PickerActions[PickerActions["None"] = 0] = "None";
    PickerActions[PickerActions["Pick"] = 1] = "Pick";
    PickerActions[PickerActions["Reset"] = 2] = "Reset";
    PickerActions[PickerActions["Default"] = 3] = "Default";
    PickerActions[PickerActions["Edit"] = 4] = "Edit";
    PickerActions[PickerActions["Create"] = 8] = "Create";
    PickerActions[PickerActions["All"] = 15] = "All";
})(PickerActions || (PickerActions = {}));
;
